import { useState } from "react";
import { NavLink } from "react-router";
import { ModelWindow } from "../../../Components/ModelWindow/ModelWindow";
import { SignUpModel } from "../../../Components/Public/WelcomePage/Header/SignUpModel/SignUpModel";
import {
  ButtonsContainer,
  ButtonSignUp,
  HeaderContainer,
} from "./Header.styled";
import { LogoApp } from "../../../Components/LogoApp/LogoApp";
import { useLanguageContext } from "../../../Components/Languages/Langs/LanguageContext";

export const SignInHeader = () => {
  const { t } = useLanguageContext();
  const [showSignIn, setShowSignIn] = useState(false);
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);

  const openSignIn = () => {
    setShowSignIn(true);
    setTimeout(() => setIsSignUpOpen(true), 0);
  };

  const closeSignIn = () => {
    setIsSignUpOpen(false);
    setTimeout(() => setShowSignIn(false), 250);
  };

  return (
    <>
      <header>
        <HeaderContainer>
          <NavLink to="/">
            <LogoApp />
          </NavLink>

          <ButtonsContainer>
            <ButtonSignUp type="button" onClick={openSignIn}>
              {t("publicTranslate.FormsAndModel.PageSignIn.Header.ButtonSignUp")}
            </ButtonSignUp>
          </ButtonsContainer>
        </HeaderContainer>

        {showSignIn && (
          <ModelWindow onClose={closeSignIn} isOpen={isSignUpOpen}>
            <SignUpModel onClose={closeSignIn} />
          </ModelWindow>
        )}
      </header>
    </>
  );
};
